/**
 * Arabic for inspection rounds carried to the platform — what the shell says
 * when a round is saved or refused, and the marks on the boards' round tables
 * (translated in place by the board translator, so whole texts only).
 * Proposed; pending native aviation review.
 */
const ar: Record<string, string> = {
  /* the shell's notice */
  "Round {ref} saved on the platform.": "حُفظت الجولة {ref} على المنصة.",
  "{n} work order raised:|{n} work orders raised:":
    "لم يُفتح أي أمر عمل:|فُتح أمر عمل واحد:|فُتح أمرا عمل:|فُتحت {n} أوامر عمل:|فُتح {n} أمر عمل:|فُتح {n} أمر عمل:",
  "{n} finding has no photo.|{n} findings have no photo.":
    "لا توجد ملاحظة بلا صورة.|ملاحظة واحدة بلا صورة.|ملاحظتان بلا صورة.|{n} ملاحظات بلا صور.|{n} ملاحظة بلا صور.|{n} ملاحظة بلا صور.",
  "The platform did not raise this one.": "لم تفتح المنصة هذا الأمر.",
  "The platform has no checklist for this round yet. It stays on this screen until you reload.":
    "لا توجد على المنصة قائمة فحص لهذه الجولة بعد. تبقى على هذه الشاشة حتى تُعيد تحميلها.",
  "The platform's checklist has no item for: {topics}.": "لا يوجد في قائمة الفحص على المنصة بند لـ: {topics}.",

  /* the boards' round tables */
  SAVING: "جارٍ الحفظ",
  "NO PHOTOS": "بلا صور",
  "The findings were saved without photos.": "حُفظت الملاحظات بلا صور.",
  "Can't show the rounds saved on the platform.": "تعذّر عرض الجولات المحفوظة على المنصة.",
  "Only rounds entered on this screen are listed.": "تُعرض فقط الجولات المُدخلة على هذه الشاشة.",
};
export default ar;
